"use client";

/**
 * The root layout itself failed (#788 PR2): nothing of the site's — its
 * styles, its shell — is here, so this is plain on purpose. Recorded, if they
 * agreed to the browser's record, and said in the console.
 */
import { useEffect } from "react";
import { record } from "@/components/shell/record";
import { langOf, t } from "@/lib/i18n/index";

export default function GlobalError({ error, retry }: { error: Error & { digest?: string }; retry: () => void }) {
  const lang = langOf(typeof document !== "undefined" ? document.documentElement.lang : undefined);
  const s = t(lang);
  useEffect(() => {
    record("client_error", { surface: "root", kind: "render" });
    console.error("[root]", error);
  }, [error]);
  return (
    <html lang={lang}>
      <body style={{ fontFamily: "system-ui, sans-serif", maxWidth: 560, margin: "64px auto", padding: "0 16px", lineHeight: 1.6 }}>
        <title>{s["error.title"]}</title>
        <h1 style={{ fontSize: 20 }}>{s["error.title"]}</h1>
        <p>{s["error.body"]}</p>
        <button type="button" onClick={() => retry()}>{s["error.retry"]}</button>
      </body>
    </html>
  );
}
